import { Action } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

import * as Objects from '@core/objects';
import * as Search from '@app/models/search';
import { VersionFeedback } from '@core/models/version-feedback';

export enum ApprovalsActionType {

	// ACTION TYPES
    Init = "[Approvals] first call",

    LoadFilterLabels = "[Approvals] GET - Obtain labels filters - GET",
    LoadFilterLabelsSuccess = "[Approvals] GET - Obtain labels filter SUCCESS",
    LoadFilterLabelsError = "[Approvals] GET - Obtain labels filter ERROR",
    LoadFilterUsers = "[Approvals] GET - Obtain users filters - GET",
    LoadFilterUsersSuccess = "[Approvals] GET - Obtain users filter SUCCESS",
    LoadFilterUsersError = "[Approvals] GET - Obtain users filter ERROR",
    LoadFilterUsersErrorNoResponse = "[Approvals] GET - Obtain users filter NO RESPONSE",

    SetVersionStatus = "[Approvals] PUT - Set single version status",
    SetVersionStatusSuccess = "[Approvals] PUT - Set single version status SUCCESS",
    SetVersionStatusError = "[Approvals] PUT - Set single version status ERROR",

    PushSearchFilters = "[Approvals] Add filter (silence mode)",
    ApplySearchFilter = "[Approvals] Add filter",
    RemoveSearchFilter = "[Approvals] Remove filter",

    SetSearchTerm = "[Approvals] set search term",

    UpdateQueryParams = "[Approvals] update search query params",
    SetQueryParams = "[Approvals] set search query params",
    LoadResults = "[Approvals] dispatch search / load the versions results",
    UpdateResultItemsStatus = "[Approvals] set selected results status",

    LoadMoreCompletedResults = "[Approvals] dispatch search / load the versions results completed",
    LoadMoreUncompletedResults = "[Approvals] dispatch search / load the versions results uncompleted ",

    LoadUncompletedResults = "[Approvals] dispatch search / load outstanding results - GET",
    LoadUncompletedResultsSuccess = "[Approvals] dispatch search / load outstanding results - GET SUCCESS",
    LoadUncompletedResultsError = "[Approvals] dispatch search / load outstanding results - GET ERROR",

    LoadCompletedResults = "[Approvals] dispatch search / load completed results - GET",
    LoadCompletedResultsSuccess = "[Approvals] dispatch search / load completed results - GET SUCCESS",
    LoadCompletedResultsError = "[Approvals] dispatch search / load completed results - GET ERROR",

    LoadUncompletedResultsFeedbacks = "[Approvals] dispatch load uncompleted results feedbacks - GET",
    LoadUncompletedResultsFeedbacksSuccess = "[Approvals] dispatch load uncompleted results feedbacks - GET SUCCESS",
    LoadUncompletedResultsFeedbacksError = "[Approvals] dispatch load uncompleted results feedbacks - GET ERROR",
  
    LoadCompletedResultsFeedbacks = "[Approvals] dispatch load completed results feedbacks - GET",
    LoadCompletedResultsFeedbacksSuccess = "[Approvals] dispatch load completed results feedbacks - GET SUCCESS",
    LoadCompletedResultsFeedbacksError = "[Approvals] dispatch load completed results feedbacks - GET ERROR",

    ResultsFeedbacksPreSuccess = "[Approvals] dispatch process results status for feedbacks",

    UpdateVersion = "[Approvals] dispatch search a version - GET",
    UpdateVersionSuccess = "[Approvals] dispatch search a version - GET SUCCESS",
    UpdateVersionError = "[Approvals] dispatch search a version - GET ERROR",

    UpdateVersionFeedbacks = "[Approvals] dispatch update a version feedbacks - GET",

    ReloadResults = "[Approvals]  set page to 1 and reload results - GET",

    Clear = "[Approvals] clear data",
    ResetFeedbacks = "[Approvals] clear feedbacks data after refine search"
}

// Available Actions 
export class Init implements Action {
    readonly type = ApprovalsActionType.Init;
    constructor(public params: Search.SearchQueryParams,public feedbackAccess: boolean, public approvalsGlobalAccess: boolean | string) {}
}

export class LoadFilterLabels implements Action {
    readonly type = ApprovalsActionType.LoadFilterLabels;
    constructor() {}
}

export class LoadFilterLabelsSuccess implements Action {
    readonly type = ApprovalsActionType.LoadFilterLabelsSuccess;
    constructor(public labels: Array<Objects.Label>) {}
}

export class LoadFilterLabelsError implements Action {
    readonly type = ApprovalsActionType.LoadFilterLabelsError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadFilterUsers implements Action {
    readonly type = ApprovalsActionType.LoadFilterUsers;
    constructor() {}
}

export class LoadFilterUsersSuccess implements Action {
    readonly type = ApprovalsActionType.LoadFilterUsersSuccess;
    constructor(public users: Array<Objects.User>) {}
}

export class LoadFilterUsersError implements Action {
    readonly type = ApprovalsActionType.LoadFilterUsersError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadFilterUsersErrorNoResponse implements Action {
    readonly type = ApprovalsActionType.LoadFilterUsersErrorNoResponse;
    constructor(public error: any) {}
}

export class SetVersionStatus implements Action {
    readonly type = ApprovalsActionType.SetVersionStatus;
    constructor(public versionId, public status: Objects.Status) {}
}

export class SetVersionStatusSuccess implements Action {
    readonly type = ApprovalsActionType.SetVersionStatusSuccess;
    constructor(public version: Objects.Version) {}
}

export class SetVersionStatusError implements Action {
    readonly type = ApprovalsActionType.SetVersionStatusError;
    constructor(public error: HttpErrorResponse) {}
}

export class ApplySearchFilter implements Action {
    readonly type = ApprovalsActionType.ApplySearchFilter;
    constructor(public filter: Search.SearchAppliedFilter) {}
}

export class PushSearchFilters implements Action {
    readonly type = ApprovalsActionType.PushSearchFilters;
    constructor(public filters: Search.SearchAppliedFilter[]) {}
}

export class RemoveSearchFilter implements Action {
    readonly type = ApprovalsActionType.RemoveSearchFilter;
    constructor(public filter: Search.SearchAppliedFilter) {}
}

export class SetSearchTerm implements Action {
    readonly type = ApprovalsActionType.SetSearchTerm;
    constructor(public term: string) {}
}

export class UpdateQueryParams implements Action {
    readonly type = ApprovalsActionType.UpdateQueryParams;
    constructor() {}
}

export class SetQueryParams implements Action {
    readonly type = ApprovalsActionType.SetQueryParams;
    constructor(public params: Search.SearchQueryParams) {}
}

export class UpdateResultItemsStatus implements Action {
    readonly type = ApprovalsActionType.UpdateResultItemsStatus;
    constructor(public status: string){}
}


export class LoadResults implements Action {
    readonly type = ApprovalsActionType.LoadResults;
    constructor() {}
}

export class LoadMoreCompletedResults implements Action {
    readonly type = ApprovalsActionType.LoadMoreCompletedResults;
    constructor() {}
}

export class LoadMoreUncompletedResults implements Action {
    readonly type = ApprovalsActionType.LoadMoreUncompletedResults;
    constructor() {}
}

export class LoadUncompletedResults implements Action {
    readonly type = ApprovalsActionType.LoadUncompletedResults;
    constructor() {}
}

export class LoadUncompletedResultsSuccess implements Action {
    readonly type = ApprovalsActionType.LoadUncompletedResultsSuccess;
    constructor(public versions: Array<Objects.Version>) {}
}

export class LoadUncompletedResultsError implements Action {
    readonly type = ApprovalsActionType.LoadUncompletedResultsError;
    constructor(public error:  HttpErrorResponse) {}
}

export class LoadCompletedResults implements Action {
    readonly type = ApprovalsActionType.LoadCompletedResults;
    constructor() {}
}

export class LoadCompletedResultsSuccess implements Action {
    readonly type = ApprovalsActionType.LoadCompletedResultsSuccess;
    constructor(public versions: Array<Objects.Version>) {}
}

export class LoadCompletedResultsError implements Action {
    readonly type = ApprovalsActionType.LoadCompletedResultsError;
    constructor(public error:  HttpErrorResponse) {}
}

export class LoadUncompletedResultsFeedbacks implements Action {
    readonly type = ApprovalsActionType.LoadUncompletedResultsFeedbacks;
    constructor(public versions: Array<Objects.Version>) {}
}

export class LoadUncompletedResultsFeedbacksSuccess implements Action {
    readonly type = ApprovalsActionType.LoadUncompletedResultsFeedbacksSuccess;
    constructor(public feedbacks: Array<VersionFeedback>) {}
}


export class LoadUncompletedResultsFeedbacksError implements Action {
    readonly type = ApprovalsActionType.LoadUncompletedResultsFeedbacksError;
    constructor(public error:  HttpErrorResponse) {}
}

export class LoadCompletedResultsFeedbacks implements Action {
    readonly type = ApprovalsActionType.LoadCompletedResultsFeedbacks;
    constructor(public versions: Array<Objects.Version>) {}
}

export class LoadCompletedResultsFeedbacksSuccess implements Action {
    readonly type = ApprovalsActionType.LoadCompletedResultsFeedbacksSuccess;
    constructor(public feedbacks: Array<VersionFeedback>) {}
}

export class LoadCompletedResultsFeedbacksError implements Action {
    readonly type = ApprovalsActionType.LoadCompletedResultsFeedbacksError;
    constructor(public error:  HttpErrorResponse) {}
}

export class ResultsFeedbacksPreSuccess implements Action {
    readonly type = ApprovalsActionType.ResultsFeedbacksPreSuccess;
    constructor(public feedbacks: Array<VersionFeedback>, public resultsType: string) {}
}

export class UpdateVersion implements Action {
    readonly type = ApprovalsActionType.UpdateVersion;
    constructor(public versionId: number | string, public eventName: string) {}
}

export class UpdateVersionSuccess implements Action {
    readonly type = ApprovalsActionType.UpdateVersionSuccess;
    constructor(public versionId: number | string, public versions: Array<Objects.Version>) {}
}

export class UpdateVersionError implements Action {
    readonly type = ApprovalsActionType.UpdateVersionError;
    constructor(public versionId: number | string, public error:  HttpErrorResponse) {}
}

export class UpdateVersionFeedbacks implements Action {
    readonly type = ApprovalsActionType.UpdateVersionFeedbacks;
    constructor(public versionId: number) {}
}

export class ReloadResults implements Action {
    readonly type = ApprovalsActionType.ReloadResults;
    constructor() {}
}

export class Clear implements Action {
    readonly type = ApprovalsActionType.Clear;
    constructor() {}
}

export class ResetFeedbacks implements Action {
    readonly type = ApprovalsActionType.ResetFeedbacks;
    constructor() {}
}


export type ApprovalsActions = 	Init |
                                
                                LoadFilterLabels |
                                LoadFilterLabelsSuccess |
                                LoadFilterLabelsError |

                                LoadFilterUsers |
                                LoadFilterUsersSuccess |
                                LoadFilterUsersError | 
                                LoadFilterUsersErrorNoResponse |

                                SetVersionStatus |
                                SetVersionStatusSuccess |
                                SetVersionStatusError |
                                
                                PushSearchFilters |
                                ApplySearchFilter |
                                RemoveSearchFilter |

                                SetSearchTerm |
                                UpdateQueryParams |
                                SetQueryParams | 
                                LoadResults |
                                UpdateResultItemsStatus |

                                LoadMoreCompletedResults |
                                LoadMoreUncompletedResults |

                                LoadUncompletedResults |
                                LoadUncompletedResultsSuccess |
                                LoadUncompletedResultsError |

                                LoadCompletedResults |
                                LoadCompletedResultsSuccess | 
                                LoadCompletedResultsError |

                                LoadUncompletedResultsFeedbacks | 
                                LoadUncompletedResultsFeedbacksSuccess |
                                LoadUncompletedResultsFeedbacksError |

                                LoadCompletedResultsFeedbacks | 
                                LoadCompletedResultsFeedbacksSuccess |
                                LoadCompletedResultsFeedbacksError |

                                ResultsFeedbacksPreSuccess |

                                UpdateVersion |
                                UpdateVersionSuccess |
                                UpdateVersionError |

                                UpdateVersionFeedbacks |

                                ReloadResults |

                                Clear |
                                ResetFeedbacks
                                ;
